import { type BimQueryTarget, probeBimQuery } from "./bimQuery";
import { procoreClient } from "./client";
import type { SceneReadBackend } from "./errors";

/**
 * Probe the backend that reported a cache miss without raising another backfill signal.
 * BIM Query needs bim_index and metadata; the legacy ping needs the text index,
 * which Black Marlin does not produce. A LIGHT read checks both BIM Query artifacts.
 * `sceneSliceId` narrows only the BIM Query probe; the legacy ping is version-level.
 */
export async function isProcoreSceneReady(
    params: BimQueryTarget & { signal?: AbortSignal; backend?: SceneReadBackend },
): Promise<boolean> {
    if (params.backend === "bim-query") {
        return probeBimQuery(params, { signal: params.signal });
    }
    return procoreClient<boolean>(
        `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/bim/scenes/${params.sceneId}/versions/${params.sceneVersionId}/ping`,
        {
            method: "GET",
            parseResponse: (res) => res.status === 200,
            signal: params.signal,
        },
    );
}
